import swal from "sweetalert";
import { toast } from "react-toastify";
import React, { Component } from "react";
import Table from 'react-bootstrap/Table';
import SearchSharpIcon from '@material-ui/icons/SearchSharp';
import MoreVertSharpIcon from "@material-ui/icons/MoreVertSharp";
import { FormControl, InputGroup, Button, Form, Dropdown, Badge, OverlayTrigger, Tooltip } from 'react-bootstrap';
import axios from '../../../axios';
import apiError from '../../../error';
import Loader from "../../../component/loader/loader";
import { getDate, getCookie, debounce, getDateWithoutTime } from "../../../function";
import Doamin from '../../../component/domain/domain';
import Pagination from "react-js-pagination";
import { IoInformationOutline } from "react-icons/io5";
import AddDomain from "../../../component/add-domain/index";
import VerifyDomain from "../../../component/verify-domain";
import { PiPlusBold } from "react-icons/pi";

const PRIMARY_DOMAIN_SELECT_INITIAL_LIMIT = 20;

const mapPrimaryDomains = (landingUrls) =>
    (Array.isArray(landingUrls) ? landingUrls : [])
        .filter((landingUrl) => !landingUrl.parentId)
        .map((landingUrl) => ({
            id: landingUrl.id,
            name: landingUrl.name,
            tlsEnabled: landingUrl.tlsEnabled,
            companyId: landingUrl.companyId,
        }));

export default class Landing_URL_List extends Component {
    constructor(props) {
        super(props);
        this.state = {
            url: [],
            count: 0,
            limit: 10,
            search: '',
            activePage: 1,
            modal: false,
            domain: '',
            subDomain: '',
            loading: true,
            landingUrlId: 0,
            landing_urls: [],
            userType: getCookie('userType'),
            userAgent: getCookie('userAgent'),
            companyId: null,
            tlsCooldown: 5000,
            status: "",
            verifyModalOpen: false,
            verifyModalUrlId: null,
            showLimitSelected: false,
            /** First page of primary domains for Add Domain select. */
            primaryDomainsForSelect: [],
            primaryDomainsLoading: false,
            primaryDomainsSearching: false,
            primaryDomainSelectTotal: 0,
        }
        this.primaryDomainSearchRequestId = 0;
    }

    componentDidMount = () => {
        this.load();
    }

    load = debounce(() => {
        axios.get('/api/pages/url', {
            params: {
                page: this.state.activePage,
                limit: this.state.limit,
                search: this.state.search,
                status: this.state.status
            }
        })
            .then(res => {
                const landing_urls = res.data.landing_urls || [];
                const url = mapPrimaryDomains(landing_urls);
                this.setState({
                    loading: false,
                    url,
                    count: res.data.count,
                    landing_urls,
                    companyId: res.data.companyId,
                });
            })
            .catch(error => {
                apiError(error);
                this.setState({ loading: false });
            })
    }, 500)

    handleDeleteURL = () => {
        swal({
            title: "Do you want to delete Landing URL?",
            icon: "warning",
            buttons: ['No', 'Yes'],
            dangerMode: true,
        })
            .then(async willSuccess => {
                if (willSuccess) {

                }
            })
    }

    /** Load first {PRIMARY_DOMAIN_SELECT_INITIAL_LIMIT} primary domains for the dropdown. */
    loadInitialPrimaryDomainsForSelect = () => {
        this.setState({ primaryDomainsLoading: true });
        axios
            .get('/api/pages/url', {
                params: {
                    page: 1,
                    limit: PRIMARY_DOMAIN_SELECT_INITIAL_LIMIT,
                    search: '',
                    status: this.state.status,
                },
            })
            .then((res) => {
                const landing_urls = res.data.landing_urls || [];
                const total =
                    res.data.count != null ? Number(res.data.count) : landing_urls.length;
                this.setState({
                    primaryDomainsForSelect: mapPrimaryDomains(landing_urls),
                    primaryDomainSelectTotal: Number.isNaN(total) ? 0 : total,
                    primaryDomainsLoading: false,
                    primaryDomainsSearching: false,
                });
            })
            .catch((error) => {
                apiError(error);
                this.setState({ primaryDomainsLoading: false });
            });
    };

    /** Server search when list has more than 15 — finds domains by name via API. */
    searchPrimaryDomainsForSelect = (search) => {
        const query = (search || '').trim();

        if (!query) {
            this.loadInitialPrimaryDomainsForSelect();
            return;
        }

        const requestId = ++this.primaryDomainSearchRequestId;
        this.setState({ primaryDomainsSearching: true });

        axios
            .get('/api/pages/url', {
                params: {
                    page: 1,
                    limit: 100,
                    search: query,
                    status: this.state.status,
                },
            })
            .then((res) => {
                if (requestId !== this.primaryDomainSearchRequestId) {
                    return;
                }
                this.setState({
                    primaryDomainsForSelect: mapPrimaryDomains(res.data.landing_urls || []),
                    primaryDomainsSearching: false,
                });
            })
            .catch((error) => {
                if (requestId !== this.primaryDomainSearchRequestId) {
                    return;
                }
                apiError(error);
                this.setState({ primaryDomainsSearching: false });
            });
    };

    showModal = () => {
        this.primaryDomainSearchRequestId += 1;
        this.setState({ modal: true, landingUrlId: 0 });
        this.loadInitialPrimaryDomainsForSelect();
    }

    hideModal = () => {
        this.setState({ modal: false, landingUrlId: 0 });
    }

    handleSubDomain = (e) => {
        this.setState({ subDomain: e.target.value })
    }

    handleLandingUrlId = (landingUrlId) => {
        this.setState({ landingUrlId: landingUrlId })
    }

    validURL = (str) => {
        var pattern = new RegExp(
            '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
            '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
            '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
            '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
            '(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator
        return !!pattern.test(str);
    }

    handleSubmit = () => {
        if (this.state.landingUrlId === 0 || parseInt(this.state.landingUrlId, 10) === 0) {
            toast.error('Please Select Domain First');
            return null;
        } else if (!this.state.subDomain || this.state.subDomain.length === 0) {
            toast.error('Please Enter SubDomain');
            return null;
        } else {
            if (this.state.subDomain.startsWith('http')) {
                toast.error("Please Enter Sub Domain Without http:// or https://");
                return;
            }

            this.setState({ loading: true });
            axios.post('/api/pages/subDomain', {
                subDomain: this.state.subDomain,
                landingUrlId: this.state.landingUrlId
            })
                .then(res => {
                    this.load();
                    toast.success("Subdomain Added Successfully");
                    this.setState({ loading: false, modal: false });
                })
                .catch(err => {
                    apiError(err);
                    this.setState({ loading: false });
                })
        }
    }

    handleCreate = () => {
        if (this.state.domain.length === 0) {
            toast.error("Please Enter Landing URL");
            return;
        }
        if (this.state.domain.startsWith('http')) {
            toast.error("Please Enter Landing URL Without http:// or https://");
            return;
        }
        if (!this.validURL(this.state.domain)) {
            toast.error("Please Enter Valid Landing URL");
            return;
        }
        this.setState({ loading: true });
        axios.post('/api/pages/url', { url: this.state.domain })
            .then(res => {
                toast.success('Landing URL Added Successfully');
                this.setState({ loading: false, domainModal: false });
                if (res.data.isAdmin) {
                    this.load();
                } else {
                    this.props.history.push(`/landing-url/${res.data.landingUrlId}`);
                }
            })
            .catch(err => {
                apiError(err);
                this.setState({ loading: false });
            });
    };

    handlePrimaryDomainSubmit = (domain) => {
        const url = (domain || '').trim();
        if (!url) {
            toast.error("Please Enter Domain");
            return;
        }
        if (url.startsWith('http')) {
            toast.error("Please Enter Domain Without http:// or https://");
            return;
        }
        if (!this.validURL(url)) {
            toast.error("Please Enter Valid Domain");
            return;
        }
        this.setState({ loading: true });
        axios.post('/api/pages/url', { url })
            .then(res => {
                toast.success('Landing URL Added Successfully');
                this.setState({ loading: false, modal: false });
                this.load();
                this.loadInitialPrimaryDomainsForSelect();
                if (res.data && !res.data.isAdmin && res.data.landingUrlId) {
                    this.props.history.push(`/landing-url/${res.data.landingUrlId}`);
                }
            })
            .catch(err => {
                apiError(err);
                this.setState({ loading: false });
            });
    };

    handleSubDomainSubmit = ({ landingUrlId, subDomain }) => {
        const id = parseInt(landingUrlId, 10);
        const sub = (subDomain || '').trim();
        if (!id || id === 0) {
            toast.error('Please Select Primary Domain');
            return;
        }
        if (!sub) {
            toast.error('Please Enter Sub Domain');
            return;
        }
        if (sub.startsWith('http')) {
            toast.error("Please Enter Sub Domain Without http:// or https://");
            return;
        }
        this.setState({ loading: true });
        axios.post('/api/pages/subDomain', { subDomain: sub, landingUrlId: id })
            .then(res => {
                toast.success("Subdomain Added Successfully");
                this.setState({ loading: false, modal: false });
                this.load();
                this.loadInitialPrimaryDomainsForSelect();
            })
            .catch(err => {
                apiError(err);
                this.setState({ loading: false });
            });
    };

    deleteLandingUrl = (landingUrlId) => {
        this.setState({ loading: true })
        axios.delete(`/api/pages/delete?landingUrlId=${landingUrlId}`)
            .then(res => {
                toast.success('Landing URL Deleted Successfully')
                this.load();
            })
            .catch(err => {
                apiError(err)
                this.setState({ loading: false })
            })
    }

    removeDeceptive = (landingUrlId) => {
        this.setState({ loading: true })
        axios.get(`/api/pages/removeDeceptive/${landingUrlId}`)
            .then(res => {
                toast.success('Updated Successfully')
                this.load();
            })
            .catch(err => {
                apiError(err)
                this.setState({ loading: false })
            })
    }

    enableTlsToggle = (idx, currentTlsEnabled) => {
        const newLandingUrls = this.state.landing_urls;
        newLandingUrls[idx] = { ...this.state.landing_urls[idx], tlsEnabled: !currentTlsEnabled, disabled: false }

        this.setState({ landing_urls: newLandingUrls })
    }

    //tls toggle function
    toggleTLS = (landingUrlId, currentTlsEnabled) => {
        const apiEndpoint = currentTlsEnabled ? `/api/tls/disable-tls/${landingUrlId}` : `/api/tls/enable-tls/${landingUrlId}`;
        const successMessage = currentTlsEnabled ? 'SSL Disabled' : 'SSL Enabled';

        this.setState({ loading: true });

        axios.get(apiEndpoint)
            .then(res => {
                // Update the TLS state for the specific landing URL
                this.setState(state => ({
                    landing_urls: state.landing_urls.map((url, idx) => {
                        // Disable tls toggle button for specific time
                        if (url.id === landingUrlId && !currentTlsEnabled) {
                            setTimeout(() => this.enableTlsToggle(idx, currentTlsEnabled), this.state.tlsCooldown);
                            return { ...url, tlsEnabled: !currentTlsEnabled, disabled: true }
                        }

                        return url.id === landingUrlId ? { ...url, tlsEnabled: !currentTlsEnabled } : url
                    }
                    ),
                    loading: false
                }));
                toast.success(successMessage);
            })
            .catch(err => {
                apiError(err);
                this.setState({ loading: false });
            });
    };

    render() {
        return (
            <div className="content-wrap">
                <div className="breadcrumbbar">
                    <div className="flexRow row">
                        <div className="col-md-4">
                            <div className="page-head d-flex align-items-center justify-content-between">
                                <h4 className="page-title">Landing URL</h4>
                            </div>
                        </div>
                        <div className="col-md-8 flexFilterButtons">
                            <div className="btn-container float-right d-flex align-items-center">
                                <Button className="btn btn-primary" onClick={this.showModal}> <PiPlusBold style={{ marginTop: '-2px' }} /> Add Domain</Button>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="contentbar">
                    {/* filter wrapper */}
                    <div className="filter-without-border">
                        <div className="align-items-center row">
                            <div className="col-md-3">
                                <div className="positionSearchIcon">
                                    <InputGroup className="search-wrap">
                                        <FormControl type="text" placeholder="Search" value={this.state.search} className="inputSearch mr-sm-2 form-control" onChange={(e) => this.setState({ search: e.target.value, activePage: 1 }, () => this.load())} /><SearchSharpIcon className="search-icon"></SearchSharpIcon>
                                    </InputGroup>
                                </div>
                            </div>
                            <div className="col-sm-9">
                                <div className="rightFilters">
                                <Dropdown className="mr-2">
                                        <Dropdown.Toggle variant="secondary" id="show-dropdown" className="dropdown-color-white">
                                            {this.state.showLimitSelected ? `Show ${this.state.limit}` : 'Show'}
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu>
                                            {[10, 20, 50, 100].map((num) => (
                                                <Dropdown.Item
                                                    key={num}
                                                    onClick={() => this.setState({ limit: num, activePage: 1, showLimitSelected: true }, () => this.load())}
                                                    active={this.state.showLimitSelected && this.state.limit === num}
                                                >
                                                    {num}
                                                </Dropdown.Item>
                                            ))}
                                        </Dropdown.Menu>
                                    </Dropdown>
                                    
                                    <Dropdown className="mr-2">
                                        <Dropdown.Toggle variant="secondary" id="status-dropdown" className="dropdown-color-white">
                                            {this.state.status || 'Status'}
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu>
                                            <Dropdown.Item
                                                onClick={() => this.setState({ status: 'Verified', activePage: 1 }, () => this.load())}
                                                active={this.state.status === 'Verified'}
                                            >
                                                Verified
                                            </Dropdown.Item>
                                            <Dropdown.Item
                                                onClick={() => this.setState({ status: 'Unverified', activePage: 1 }, () => this.load())}
                                                active={this.state.status === 'Unverified'}
                                            >
                                                Unverified
                                            </Dropdown.Item>
                                            <Dropdown.Item
                                                onClick={() => this.setState({ status: 'Deceptive', activePage: 1 }, () => this.load())}
                                                active={this.state.status === 'Deceptive'}
                                            >
                                                Deceptive
                                            </Dropdown.Item>
                                        </Dropdown.Menu>
                                    </Dropdown>

                                    
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="tableContainerWrapInner">
                        <Table>
                            <thead>
                                <tr>
                                    <th className="th-30">Url</th>
                                    <th>Domain Type</th>
                                    <th>Created On</th>
                                    <th>Status</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.landing_urls.map((domain, index) => {
                                    let url = domain.name
                                    return <tr key={index}>
                                        <td className="onlyForPinter">
                                            <a
                                                className="lgTxt"
                                                rel="noopener noreferrer"
                                                href={`${domain.tlsEnabled ? 'https://' : 'http://'}${url}`}
                                                target="_blank">{url} <Badge variant="secondary" className="badge-soft-secondary ml-2">{domain.companyId !== null ? 'Custom' : ''}</Badge>
                                            </a>
                                        </td>
                                        <td>{domain.parentId ? 'Subdomain' : 'Primary'}</td>
                                        <td>
                                            {getDateWithoutTime(domain.createdAt)}
                                        </td>
                                        <td>
                                            <div className="commonDflex align-items-center">
                                                {domain.validTo ? (
                                                    <>
                                                        <Badge variant="danger" className="badge-soft-danger mr-1">Deceptive</Badge>
                                                        <OverlayTrigger
                                                            placement="top"
                                                            overlay={
                                                                <Tooltip id={`deceptive-tooltip-${domain.id}`}>
                                                                    The URL was identified as deceptive on date of valid till {domain.validTo ? getDate(domain.validTo) : ''}
                                                                </Tooltip>
                                                            }
                                                        >
                                                            <IoInformationOutline className="text-muted ml-1" style={{ fontSize: '14px', cursor: 'pointer', backgroundColor: '#f6f6f6', borderRadius: '50%' }} aria-label="Info" />
                                                        </OverlayTrigger>
                                                    </>
                                                ) : domain.isValid ? (
                                                    <Badge variant="success" className="badge-soft-success">Verified</Badge>
                                                ) : (
                                                    <>

                                                        <Badge
                                                            variant="secondary"
                                                            className="badge-soft-secondary"
                                                        >
                                                            Unverified
                                                        </Badge>
                                                        <span
                                                            className="text-primary ml-2"
                                                            style={{ fontSize: '12px', cursor: 'pointer', textDecoration: 'underline' }}
                                                            onClick={() => this.setState({ verifyModalOpen: true, verifyModalUrlId: domain.id })}>
                                                            Verify Domain
                                                        </span>
                                                    </>
                                                )}
                                            </div>
                                        </td>

                                        <td>
                                            <Dropdown className="action-dropdown dropdownIcon" ref={this.selectRef} drop="down">
                                                <Dropdown.Toggle className="btn-only" id={`dropdown-basic-${domain.id}`} disabled={!!(domain.validTo || domain.isValid)}>
                                                    <MoreVertSharpIcon className="dot-icon"></MoreVertSharpIcon>
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu>
                                                    <Dropdown.Item onClick={e => this.props.history.push('/landing-url/' + domain.id)} disabled={!!(domain.validTo || domain.isValid)}>Verify</Dropdown.Item>
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </td>
                                    </tr>
                                })}
                            </tbody>
                        </Table>
                        {/* <p style={{ marginTop: '5px', fontSize: '13px'}}>Total Landing URL: {this.state.landing_urls.length}</p> */}
                        <div className="pagination-Wrap">
                            <div className="row">
                                <div className="col-md-6">
                                    {!this.state["loading"] ? (
                                        <Pagination
                                            itemClass="page-item"
                                            linkClass="page-link"
                                            activePage={this.state.activePage}
                                            itemsCountPerPage={this.state.limit}
                                            totalItemsCount={this.state.count}
                                            onChange={(pageNumber) =>
                                                this.setState({ activePage: pageNumber }, () =>
                                                    this.load()
                                                )
                                            }
                                        />
                                    ) : null}
                                </div>
                                <div className="col-md-6 text-right d-flex align-items-center footer-pg">
                                    <div className="w-100 pgCount">
                                        <p>
                                            {this.state.count === 0
                                                ? 0
                                                : this.state.activePage * this.state.limit + 1 - this.state.limit}
                                            -
                                            {this.state.activePage * this.state.limit > this.state.count
                                                ? this.state.count
                                                : this.state.activePage * this.state.limit}{" "}
                                            of {this.state.count} records
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {this.state.loading ? <Loader></Loader> : null}
                    <AddDomain
                        showModal={this.state.modal}
                        hideModal={this.hideModal}
                        landingUrl={this.state.primaryDomainsForSelect}
                        primaryDomainsLoading={this.state.primaryDomainsLoading}
                        primaryDomainsSearching={this.state.primaryDomainsSearching}
                        primaryDomainSelectTotal={this.state.primaryDomainSelectTotal}
                        onSearchPrimaryDomains={this.searchPrimaryDomainsForSelect}
                        onPrimarySubmit={this.handlePrimaryDomainSubmit}
                        onSubSubmit={this.handleSubDomainSubmit}
                    />
                    <VerifyDomain
                        show={this.state.verifyModalOpen}
                        onHide={() => this.setState({ verifyModalOpen: false, verifyModalUrlId: null })}
                        urlId={this.state.verifyModalUrlId}
                        onVerified={() => this.load()}
                        history={this.props.history}
                    />
                    <Doamin
                        showModal={this.state.domainModal}
                        hideModal={e => this.setState({ domainModal: false })}
                        domain={this.state.domain}
                        handleDomain={e => this.setState({ domain: e.target.value })}
                        handleCreate={this.handleCreate}
                    ></Doamin>
                </div>
            </div>
        );
    }
}
